const stats = [
  { value: "70+", label: "Apps Delivered" },
  { value: "40+", label: "Global Clients" },
  { value: "12+", label: "Countries" },
  { value: "5.0★", label: "Avg. Rating" },
];

function StatsStripWeDevelop() {
  return (
    <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 pt-2 pb-1">
      {stats.map((stat, i) => (
        <div
          key={i}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/70 border border-[#5231E7]/15 shadow-sm backdrop-blur-sm"
        >
          <span className="text-[#5231E7] font-bold text-sm md:text-base leading-none">
            {stat.value}
          </span>
          <span className="text-gray-500 text-xs md:text-sm leading-none">
            {stat.label}
          </span>
        </div>
      ))}
    </div>
  );
}

export default StatsStripWeDevelop;
